import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import { LegalFooter } from "@/components/LegalFooter";

/** Shared public layout: eyka backdrop, min-h-screen content, footer without overscroll gap. */
export const PublicPageShell = observer(function PublicPageShell({
    children,
    contentClassName = "",
    footerLanguageSwitcher = false,
}: {
    children: ReactNode;
    contentClassName?: string;
    footerLanguageSwitcher?: boolean;
}) {
    return (
        <div className="public-shell">
            <div className="public-shell-veil" />
            <div className="public-shell-scroll">
                <div className="min-h-full w-full flex flex-col">
                    <div className={`public-shell-content ${contentClassName}`}>
                        {children}
                    </div>
                    <LegalFooter showLanguageSwitcher={footerLanguageSwitcher} />
                </div>
            </div>
        </div>
    );
});
